import React from 'react'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { Delete } from './Delete'
import type { useToggle } from 'react-use'
import { BusyButtonLink } from '@ztechapps/webui.button'
import { useBillOfMaterialsContext } from './Context'

export type RowContextMenuProps = {
  productId: string
  bomId: string
  showAddNewToggle: ReturnType<typeof useToggle>
  showExtensionToggle: ReturnType<typeof useToggle>
}

export const RowContextMenu = ({ productId, bomId, showAddNewToggle, showExtensionToggle }: RowContextMenuProps) => {
  const [showExtension] = showExtensionToggle

  return (
    <HorizontalStack gap={2}>
      <ShowIf condition={showExtension}>
        <AddNewButton showAddNewToggle={showAddNewToggle} />
      </ShowIf>

      <Delete productId={productId} bomId={bomId} />
    </HorizontalStack>
  )
}

export const AddNewButton = ({
  showAddNewToggle,
  title,
}: {
  title?: string
  showAddNewToggle: ReturnType<typeof useToggle>
}) => {
  const [showAddNew, setShowAddNew] = showAddNewToggle
  const { canEdit } = useBillOfMaterialsContext()

  const icon = showAddNew ? 'ban' : 'plus'
  title = showAddNew ? 'Cancel' : title

  return (
    <ShowIf condition={canEdit}>
      <BusyButtonLink
        icon={icon}
        bsSize="sm"
        text={title}
        title={`Add new sub-assembly`}
        onClick={() => setShowAddNew()}
        busyText={''}
      />
    </ShowIf>
  )
}
